import i18n from '../locales/index'

export const deskCategories = [
  { name: i18n.t('libs_value_list_107'), value: 'apart' },
  { name: i18n.t('libs_value_list_108'), value: 'union' },
]
export const orderStatus = [
  { name: i18n.t('libs_table_render_59'), value: 'unpaid' },
  { name: i18n.t('libs_table_render_60'), value: 'refund' },
  { name: i18n.t('libs_table_render_61'), value: 'pending' },
  { name: i18n.t('libs_table_render_62'), value: 'paid' },
  { name: i18n.t('libs_table_render_63'), value: 'unreceived' },
  { name: i18n.t('libs_table_render_64'), value: 'unreviewed' },
  { name: i18n.t('libs_table_render_65'), value: 'finished' },
  { name: i18n.t('libs_table_render_66'), value: 'cancelled' },
  { name: i18n.t('libs_table_render_67'), value: 'waiting_confirmed' },
  { name: i18n.t('libs_table_render_60'), value: 'refunded' },
  { name: i18n.t('libs_table_render_68'), value: 'discarded' }
]
export const paymentMethods = [
  { name: i18n.t('libs_table_render_74'), value: 'cash_pay' },
  { name: i18n.t('libs_table_render_77'), value: 'lcsw_ali_pay' },
  { name: i18n.t('libs_table_render_76'), value: 'lcsw_wx_pay' },
  { name: i18n.t('libs_table_render_75'), value: 'svc_pay' },
  { name: i18n.t('libs_table_render_78'), value: 'bank_card' },
  { name: i18n.t('libs_table_render_79'), value: 'alipay_offline' },
  { name: i18n.t('libs_table_render_80'), value: 'wx_pay_offline' },
  { name: i18n.t('libs_table_render_81'), value: 'meituan_pay_offline' }
]
export const orderModes = [
  { name: i18n.t('libs_value_list_109'), value: 'desk' },
  { name: i18n.t('libs_value_list_110'), value: 'pickup' },
  { name: i18n.t('libs_value_list_111'), value: 'mixin' },
  { name: i18n.t('libs_value_list_112'), value: 'retail' },
]
export const deskPaymentModes = [
  { name: i18n.t('libs_value_list_113'), value: 'eat_first' },
  { name: i18n.t('libs_value_list_114'), value: 'pay_first' },
]
export const pickupPaymentMode = [
  { name: i18n.t('libs_value_list_113'), value: 'eat_first' },
  { name: i18n.t('libs_value_list_114'), value: 'pay_first' },
]
export const industrys = [
  { name: i18n.t('libs_value_list_115'), value: 'chinese' },
  { name: i18n.t('libs_value_list_116'), value: 'fresh_fruits' },
  { name: i18n.t('libs_value_list_117'), value: 'retail' },
]
export const durationList = [{
  label: i18n.t('libs_value_list_118'),
  value: 'one_year'
}, {
  label: i18n.t('libs_value_list_119'),
  value: 'three_year'
}, {
  label: i18n.t('libs_value_list_120'),
  value: 'permanent'
}]
export const scoreRewardCategories = [{ name: i18n.t('libs_table_render_95'), value: 'vip_day' }, { name: i18n.t('libs_table_render_96'), value: 'birthday' }, { name: i18n.t('libs_table_render_97'), value: 'anniversary' }]
export const scoreRewardWeeks = [{ name: i18n.t('libs_table_render_88'), value: '1' }, { name: i18n.t('libs_table_render_89'), value: '2' }, { name: i18n.t('libs_table_render_90'), value: '3' }, { name: i18n.t('libs_table_render_91'), value: '4' }, { name: i18n.t('libs_table_render_92'), value: '5' }, { name: i18n.t('libs_table_render_93'), value: '6' }, { name: i18n.t('libs_table_render_94'), value: '7' }]

export const countryMobileCodes = [{
  value: '86',
  label: i18n.t('libs_value_list_121')
}, {
  value: '66',
  label: i18n.t('libs_value_list_122')
}, {
  value: '886',
  label: i18n.t('libs_value_list_123')
}, {
  value: '852',
  label: i18n.t('libs_value_list_124')
}, {
  value: '853',
  label: i18n.t('libs_value_list_125')
}, {
  value: '1',
  label: i18n.t('libs_value_list_126')
}, {
  value: '39',
  label: i18n.t('libs_value_list_127')
}]
